module.exports = __webpack_public_path__ + "static/media/New SVG-3.3068defe.png";